import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { setLocalUser , getSuppliers, getColors, checkToken } from 'src/actions';
import { useDispatch } from 'react-redux';
// Example of user roles: ['GUEST', 'USER', 'ADMIN'];

const MFA_ROUTES = ['/auth/login/2fa-setup', '/auth/login/2fa-verify'];

// function AuthGuard({ roles, children }) {
function AuthGuard({routes, history }) {
  const session = useSelector((state) => state.session);
  const colors = useSelector((state) => state.suppliers);
  const dispatch = useDispatch();
  useEffect( () => {
    var userItem = localStorage.getItem('userLogd')
    const pathname = history.location.pathname;

    if(session.access_token && session.loggedIn){
        dispatch(checkToken(session.access_token, history))
    }
    const getStaticData = async (event) => { 
        await dispatch(getColors(session.access_token))

        await dispatch(getSuppliers())

    };

    if(session.loggedIn && (colors.colors_arr.length | colors.suppliers_arr.length) == 0){
      getStaticData()
    }
    


    if (!session.loggedIn) {
      if(userItem){ 
        dispatch(setLocalUser( JSON.parse(userItem)))
        return;
      }
      const pendingMfa = sessionStorage.getItem('mfa_pending_token');
      const onMfaRoute = MFA_ROUTES.indexOf(pathname) !== -1;
      if (onMfaRoute) {
        if (pendingMfa) {
          return;
        }
        history.push('/auth/login');
        return;
      }
      if (pathname !== '/auth/login' && pathname !== '/auth/register') {
        history.push('/auth/login');
      }
      return;

    }
    // if (!roles.includes(session.user.role)) {
    //   history.push('/errors/error-401');
    // }

    routes[4]['routes'] = routes[4]['routes'].filter((el) => {
      if(el.roll){
        return el.roll.includes(session.user.role_name);
      }else{
        return true
      }
    });

  }, [history, history.location.pathname, session.loggedIn, session]);
  
  // useEffect( () => {
  //   routes[4]['routes'] = routes[4]['routes'].filter((el) => {
  //     if(el.roll){
  //       return el.roll.includes(session.user.role_name);
  //     }
  //   });
  // }, [history, session.loggedIn, session])

  return <>{renderRoutes(routes)}</>;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
  // roles: PropTypes.array.isRequired
};

export default AuthGuard ;
